import logo  from './logo.png';
import imagen1 from './imagen1.jpg';
import sistemas from './animaciones/sistemas.png';
import componentes from './animaciones/componentes.png';
import limpieza from './animaciones/limpieza.png';
import acer1 from '../assest/computadoras/acer1.jpg'
import acer2 from '../assest/computadoras/acer2.jpg';
import acer3 from '../assest/computadoras/acer3.jpg';
import armado1 from '../assest/computadoras/armado1.jpg';
import armado2 from '../assest/computadoras/armado2.jpg';
import armado3 from '../assest/computadoras/armado3.jpg';
import armado4 from '../assest/computadoras/armado4.jpg';
import armado5 from '../assest/computadoras/armado5.jpg';
import armado6 from '../assest/computadoras/armado6.jpg';
import armado7 from '../assest/computadoras/armado7.jpg';
import asusx1 from '../assest/computadoras/asusx1.jpg';
import asusx2 from '../assest/computadoras/asusx2.jpg';
import asusx3 from '../assest/computadoras/asusx3.jpg';
import asusx4 from '../assest/computadoras/asusx4.jpg';
import asusx5 from '../assest/computadoras/asusx5.jpg';
import compuasus1 from '../assest/computadoras/compuasus1.jpg';
import compuasus2 from '../assest/computadoras/compuasus2.jpg';
import compuasus3 from '../assest/computadoras/compuasus3.jpg';
import cx1 from '../assest/computadoras/cx1.jpg';
import cx2 from '../assest/computadoras/cx2.jpg';
import cx3 from '../assest/computadoras/cx3.jpg';



export default {
    "img0": logo, 
    "img1": imagen1,
    "img3": sistemas,
    "img4": componentes,
    "img5": limpieza,
    "pc1": acer1,
    "pc2": acer2,
    "pc3": acer3,
    "pc4": armado1,
    "pc5": armado2,
    "pc6": armado3,
    "pc7": armado4,
    "pc8": armado5,
    "pc9": armado6,
    "pc10":armado7,
    "pc11": asusx1,
    "pc12": asusx2,
    "pc13": asusx3,
    "pc14": asusx4,
    "pc15": asusx5,
    "pc16": compuasus1,
    "pc17": compuasus2,
    "pc18": compuasus3,
    "pc19": cx1,
    "pc20": cx2,
    "pc21": cx3,
    
}

